module.exports = __webpack_public_path__ + "static/support-de3760487c52493f217243895722bd27.jpg";